import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dumbbell, Loader2, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
            <Dumbbell className="h-6 w-6" />
          </div>
          <p className="font-heading text-xl font-extrabold tracking-tight">FIT HOUSE</p>
        </div>
        <h1 className="font-heading text-2xl font-bold">Şifre Sıfırlama</h1>
        {sent ? (
          <p data-testid="forgot-sent" className="mt-4 rounded-lg bg-primary/10 px-4 py-3 text-sm text-foreground">
            Eğer bu e-posta kayıtlıysa, sıfırlama bağlantısı gönderildi. Lütfen gelen kutunuzu kontrol edin.
          </p>
        ) : (
          <>
            <p className="mb-6 mt-1 text-sm text-muted-foreground">E-postanızı girin, size sıfırlama bağlantısı gönderelim.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">E-posta</Label>
                <Input id="email" data-testid="forgot-email" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)} className="mt-1.5" required />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full font-semibold">
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                Bağlantı Gönder
              </Button>
            </form>
          </>
        )}
        <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-primary hover:underline">
          <ArrowLeft className="h-4 w-4" /> Girişe dön
        </Link>
      </div>
    </div>
  );
}
